/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StorageAccountResponse
 */
export interface StorageAccountResponse {
    /**
     * 
     * @type {string}
     * @memberof StorageAccountResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof StorageAccountResponse
     */
    customerId?: string;
    /**
     * 
     * @type {string}
     * @memberof StorageAccountResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof StorageAccountResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof StorageAccountResponse
     */
    provider?: StorageAccountResponseProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof StorageAccountResponse
     */
    azureStorageAccountName?: string;
    /**
     * 
     * @type {string}
     * @memberof StorageAccountResponse
     */
    azureEntraTenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof StorageAccountResponse
     */
    region?: string;
    /**
     * 
     * @type {string}
     * @memberof StorageAccountResponse
     */
    status?: StorageAccountResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof StorageAccountResponse
     */
    ownership?: StorageAccountResponseOwnershipEnum;
    /**
     * 
     * @type {boolean}
     * @memberof StorageAccountResponse
     */
    complianceAttestationAccepted?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof StorageAccountResponse
     */
    complianceAttestationAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StorageAccountResponse
     */
    lastValidatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof StorageAccountResponse
     */
    lastValidationError?: string;
    /**
     * 
     * @type {Date}
     * @memberof StorageAccountResponse
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof StorageAccountResponse
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof StorageAccountResponse
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof StorageAccountResponse
     */
    updatedBy?: string;
}


/**
 * @export
 */
export const StorageAccountResponseProviderEnum = {
    AzureBlob: 'AZURE_BLOB'
} as const;
export type StorageAccountResponseProviderEnum = typeof StorageAccountResponseProviderEnum[keyof typeof StorageAccountResponseProviderEnum];

/**
 * @export
 */
export const StorageAccountResponseStatusEnum = {
    PendingValidation: 'PENDING_VALIDATION',
    Active: 'ACTIVE',
    ValidationFailed: 'VALIDATION_FAILED',
    Disabled: 'DISABLED'
} as const;
export type StorageAccountResponseStatusEnum = typeof StorageAccountResponseStatusEnum[keyof typeof StorageAccountResponseStatusEnum];

/**
 * @export
 */
export const StorageAccountResponseOwnershipEnum = {
    CustomerManaged: 'CUSTOMER_MANAGED',
    PlatformManaged: 'PLATFORM_MANAGED'
} as const;
export type StorageAccountResponseOwnershipEnum = typeof StorageAccountResponseOwnershipEnum[keyof typeof StorageAccountResponseOwnershipEnum];


/**
 * Check if a given object implements the StorageAccountResponse interface.
 */
export function instanceOfStorageAccountResponse(value: object): value is StorageAccountResponse {
    return true;
}

export function StorageAccountResponseFromJSON(json: any): StorageAccountResponse {
    return StorageAccountResponseFromJSONTyped(json, false);
}

export function StorageAccountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorageAccountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'provider': json['provider'] == null ? undefined : json['provider'],
        'azureStorageAccountName': json['azureStorageAccountName'] == null ? undefined : json['azureStorageAccountName'],
        'azureEntraTenantId': json['azureEntraTenantId'] == null ? undefined : json['azureEntraTenantId'],
        'region': json['region'] == null ? undefined : json['region'],
        'status': json['status'] == null ? undefined : json['status'],
        'ownership': json['ownership'] == null ? undefined : json['ownership'],
        'complianceAttestationAccepted': json['complianceAttestationAccepted'] == null ? undefined : json['complianceAttestationAccepted'],
        'complianceAttestationAt': json['complianceAttestationAt'] == null ? undefined : (new Date(json['complianceAttestationAt'])),
        'lastValidatedAt': json['lastValidatedAt'] == null ? undefined : (new Date(json['lastValidatedAt'])),
        'lastValidationError': json['lastValidationError'] == null ? undefined : json['lastValidationError'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
    };
}

export function StorageAccountResponseToJSON(json: any): StorageAccountResponse {
    return StorageAccountResponseToJSONTyped(json, false);
}

export function StorageAccountResponseToJSONTyped(value?: StorageAccountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'customerId': value['customerId'],
        'name': value['name'],
        'description': value['description'],
        'provider': value['provider'],
        'azureStorageAccountName': value['azureStorageAccountName'],
        'azureEntraTenantId': value['azureEntraTenantId'],
        'region': value['region'],
        'status': value['status'],
        'ownership': value['ownership'],
        'complianceAttestationAccepted': value['complianceAttestationAccepted'],
        'complianceAttestationAt': value['complianceAttestationAt'] == null ? undefined : ((value['complianceAttestationAt']).toISOString()),
        'lastValidatedAt': value['lastValidatedAt'] == null ? undefined : ((value['lastValidatedAt']).toISOString()),
        'lastValidationError': value['lastValidationError'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'createdBy': value['createdBy'],
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'updatedBy': value['updatedBy'],
    };
}

